import React from 'react';

const IconPlay = () => (
        <svg viewBox="0 0 64 64">
          <path d="M16 12v40l36-20z" />
        </svg>
);

export default IconPlay;
